import React from 'react';
import { useTranslation } from 'react-i18next';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';
import {
  CloseButton,
  ResidenceGalleryHeaderContainer,
  GalleryInfo,
  GalleryHeaderContent,
  BuildingInfoText,
  Divider,
  DescriptionText,
  PhoneWrapper,
  LeftActionsContainer
} from './styled';
import { Icon } from '../../../Icon';
import CloseIcon from '../../../../public/static/images/close-modal.svg';
import { BottomPhoneButton } from '../../BottomPhoneButton';

interface ResidenceGalleryHeaderProps {
  galleryDescription: string;
  priceInfo: string;
  showPhoneButton?: boolean;
  phones?: string[] | null;
  pageNumber?: number;
  photosLength?: number;
  onClickHandler?: PhoneButtonClickHandler;
  onClose: () => void;
  setIsVisible?: (value: boolean) => void;
  isVisible?: boolean;
}

export const ResidenceGalleryHeader: React.FC<ResidenceGalleryHeaderProps> = ({
  galleryDescription,
  priceInfo,
  showPhoneButton = true,
  phones,
  pageNumber,
  photosLength,
  onClickHandler,
  onClose,
  setIsVisible,
  isVisible
}) => {
  const { t } = useTranslation();

  return (
    <ResidenceGalleryHeaderContainer>
      <GalleryHeaderContent data-cy="residence-gallery-header-content">
        <DescriptionText tag="title_3_new">
          {galleryDescription}
        </DescriptionText>
        <Divider />
        <BuildingInfoText tag="title_3_new">{priceInfo}</BuildingInfoText>
      </GalleryHeaderContent>
      <LeftActionsContainer>
        {showPhoneButton && onClickHandler && (
          <PhoneWrapper>
            <BottomPhoneButton
              stat="residence-gallery-phones-btn"
              isGallery
              isIconButton
              clickHandler={onClickHandler}
              phones={phones}
              setIsVisible={setIsVisible}
              isVisible={isVisible}
            />
          </PhoneWrapper>
        )}
        <CloseButton
          role="button"
          tabIndex={-1}
          onClick={onClose}
          onKeyPress={onClose}
          data-cy="gallery-close-button"
          aria-label={t('common.close')}
        >
          <Icon
            IconComponent={CloseIcon}
            height={15}
            width={15}
            indent={false}
          />
        </CloseButton>
      </LeftActionsContainer>

      {pageNumber && photosLength && (
        <GalleryInfo tag="title_3_desc">
          {pageNumber}/{photosLength}
        </GalleryInfo>
      )}
    </ResidenceGalleryHeaderContainer>
  );
};
